// 2023 Topps Star Wars New York Comic Con — authored by hand (2026-08-30)
// =============================================================================
// Source: checklist provided by Tomás, cross-checked against Trader Cracks'
// "2023 Topps Star Wars NYCC Promo Card Checklist" and TCDB. 15 white-bordered
// promo cards using 2023 flagship imagery, handed out in five-card cello packs
// at the Topps booth at New York Comic Con (October 12–15, 2023); the card
// backs carry the NYCC logo. No parallels or variants exist for the SWNY cards
// (the Sparkle cards are a separate SWBNY bonus set for High Tek box buyers —
// on CK as its own set, 2023-nycc-sparkle).
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [],
    cards: [
        { n: "SWNY-1", name: "Hondo Ohnaka – Star Wars: The Clone Wars" },
        { n: "SWNY-2", name: "Boba Fett – The Book of Boba Fett" },
        { n: "SWNY-3", name: "Babu Frik – Star Wars: The Rise of Skywalker" },
        { n: "SWNY-4", name: "Cad Bane – The Book of Boba Fett" },
        { n: "SWNY-5", name: "Jyn Erso – Rogue One: A Star Wars Story" },
        { n: "SWNY-6", name: "Krrsantan – The Book of Boba Fett" },
        { n: "SWNY-7", name: "Sebulba – Star Wars: The Phantom Menace" },
        { n: "SWNY-8", name: "Cal Kestis – Star Wars Jedi: Fallen Order" },
        { n: "SWNY-9", name: "Salacious B. Crumb – Star Wars: Return of the Jedi" },
        { n: "SWNY-10", name: "Zorii Bliss – Star Wars: The Rise of Skywalker" },
        { n: "SWNY-11", name: "Nien Nunb – Star Wars: Return of the Jedi" },
        { n: "SWNY-12", name: "Quinlan Vos – Star Wars: The Clone Wars" },
        { n: "SWNY-13", name: "Princess Leia Organa – Star Wars: A New Hope" },
        { n: "SWNY-14", name: "BB-8 – Star Wars: The Force Awakens" },
        { n: "SWNY-15", name: "Lando Calrissian – Star Wars: The Empire Strikes Back" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// The base sub-set above declares an explicit empty array (this promo set has
// no parallels), so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
